export var ResultType;
(function (ResultType) {
    ResultType["CHILD_PRODUCT"] = "childProduct";
    ResultType["PRODUCT"] = "product";
    ResultType["SPOTLIGHT"] = "spotlight";
})(ResultType || (ResultType = {}));
